var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM11.5355 5.87868L9.41421 8L11.5355 10.1213C11.9261 10.5118 11.9261 11.145 11.5355 11.5355C11.145 11.9261 10.5118 11.9261 10.1213 11.5355L8 9.41421L5.87868 11.5355C5.48816 11.9261 4.85499 11.9261 4.46447 11.5355C4.07394 11.145 4.07394 10.5118 4.46447 10.1213L6.58579 8L4.46447 5.87868C4.07394 5.48816 4.07394 4.85499 4.46447 4.46447C4.85499 4.07394 5.48816 4.07394 5.87868 4.46447L8 6.58579L10.1213 4.46447C10.5118 4.07394 11.145 4.07394 11.5355 4.46447C11.9261 4.85499 11.9261 5.48816 11.5355 5.87868Z",
    fill: "#F0F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/remove-cross.ced101d95a3941bc577319c0c01365ac.svg";
export { ForwardRef as ReactComponent };